import { PerformanceCapturePage } from '../components/ProductPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Performance Capture | Cartwheel',
  'Performance Capture turns video into production-ready motion with Comic, including multi-person, face, and hand capture.',
);

export default PerformanceCapturePage;
